<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>运营管理</a-breadcrumb-item>
    <a-breadcrumb-item>权益兑换管理</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <div style="flex: 1;"></div>
    <a-button type="primary" @click="add()"><plus-outlined />创建权益</a-button>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="false"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 权益类型 -->
      <template v-if="column.key === 'type'">
        {{ record.type === 1 ? '会员' : '虚拟币' }}
      </template>
      <!-- 核销率 -->
      <template v-if="column.key === 'rate'">
        {{ record.rate }}%
      </template>
      <!-- 失效日期 -->
      <template v-if="column.key === 'expires_at'">
        {{ record.expires_at ? dayjs(record.expires_at).format('YYYY-MM-DD') : '-' }}
      </template>
      <!-- 操作 -->
      <template v-if="column.key === 'operation'">
        <a class="operation-item" @click="download(record)">导出兑换码</a>
      </template>
    </template>
  </a-table>
  <!-- 新增、编辑项目设置 -->
  <Add ref="RefAdd" @success="getList"></Add>
</template>

<script setup>
import { onBeforeMount, ref, reactive } from 'vue'
import Add from './components-equity-exchange/Add'
import dayjs from 'dayjs'
import * as Ex from "@netjoy/excelex"
import { message } from 'ant-design-vue'
import { redeemList, redeemExport } from '@/api/copyright'

// 新增、编辑组件实例
let RefAdd = ref(null)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 200,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: '权益ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '权益名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '权益类型',
    dataIndex: 'type',
    key: 'type'
  },
  {
    title: '权益数量',
    dataIndex: 'total_number',
    key: 'total_number'
  },
  {
    title: '失效日期',
    dataIndex: 'expires_at',
    key: 'expires_at'
  },
  {
    title: '兑换码数量',
    dataIndex: 'code_number',
    key: 'code_number'
  },
  {
    title: '核销数量',
    dataIndex: 'redeem_number',
    key: 'redeem_number'
  },
  {
    title: '核销率',
    dataIndex: 'rate',
    key: 'rate'
  },
  {
    title: '创建人',
    dataIndex: 'admin_name',
    key: 'admin_name'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

// 钩子函数
onBeforeMount (() => {
  // 获取项目列表
  getList()
})

// 获取项目列表
function getList () {
  isLoading.value = true
  const params = {
    page: pagination.current,
    page_size: pagination.pageSize
  }
  redeemList(params).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      const list = data.data
      dataSource.value = list
      pagination.total = data.total
    } else {
      message.error(res.message || msg)
    }
  })
}

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  getList()
}

// 新增、编辑项目设置
function add (record) {
  RefAdd.value.showDrawer(record || {})
}

// 导出兑换码
function download (record) {
  isLoading.value = true
  redeemExport({id: record.id}).then(res => {
    isLoading.value = false
    const { code, data, msg } = res
    if (code === 0) {
      const list = data
      const codeList = list.map(item => {
        return {
          code: item,
          expires_at: record.expires_at
        }
      })
      if (codeList.length) {
        const columns = [
          {
            name: '权益兑换码',
            field: 'code',
            style: {
              colWidth: 200
            }
          },
          {
            name: '失效日期',
            field: 'expires_at',
            style: {
              colWidth: 200
            }
          }
        ]
        const sheets = [
          {
            data: codeList,
            columns: columns
          }
        ]
        Ex.ex(sheets, function (item, field, json, sheetIndex, row, col, rowCount, colCount) {
          return item
        },  `权益兑换码 - ${record.expires_at}`)
      } else {
        message.error('还没有可导出的内容')
      }
    } else {
      message.error('导出失败')
    }
  }).catch((err) => {
    message.error('导出失败')
    console.log(err)
  })
}
</script>

<style scoped>
.tool-view {
  display: flex;
  align-items: center;
  margin-top: 20px;
}
.table-view {
  margin-top: 20px;
}
.tool-title:not(:first-child) {
  margin-left: 16px;
}

</style>